export default __webpack_public_path__ + "static/media/bg-3.84786b3d.jpg";